import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carrier-menu',
  templateUrl: './carrier-menu.component.html'
})
export class CarrierMenuComponent {

}
